export const email = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const wholeNumber = /^\d+$/;
// Ten alphanumeric characters, which is all an ASIN is guaranteed to be - the same rule used in
// SourcingContainer, EditASINDialog, catalogJobs/Grid and productToPurchaseOrder.
//
// This deliberately does not encode structure. The previous rule required "B" + 2 DIGITS + 7
// alphanumeric, which described the B00-B07 range Amazon issued years ago; everything issued
// recently (B0B..., B0C..., B0D..., B0F..., B0G...) has a letter in that third position and was
// rejected as invalid - 289 of the 11,424 ASINs in one production catalog, all of them real.
export const ASIN = /^[A-Z0-9]{10}$/i;
export const UPC = /^[0-9]{12}$/;
export const DECIMAL = /^\d+\.?\d*$/;
export const VALID_DATE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
